// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const productAreaIdSchema = z.enum(["passwordless", "application_sign_in", "identity_governance", "private_access", "privileged_access", "badge_sign_in", "kiosk_pass", "non_human_identity", "windows_sign_in", "compliance", "directory"]);

export const runtimeEffectSchema = z.enum(["legacy_unchanged", "area_gates_offering", "enforced", "observed"]);

export const productAreaStateSchema = z.object({
  "activation": z.enum(["off", "setup", "on"]),
  "setup": z.enum(["not_started", "in_progress"]),
  "enforcement": z.enum(["not_applicable", "off", "observe", "enforce"]),
  "owner_subject": z.string().optional(),
  "support_contact": z.string().optional(),
  "config_generation": z.number().int().min(1),
  "version": z.number().int().min(1),
  "changed_by": z.string().optional(),
  "changed_at": z.string().datetime({ offset: true })
}).strict();

export const productAreaSchema = z.object({
  "area": productAreaIdSchema,
  "compatible": z.boolean(),
  "entitlement": z.object({
    "status": z.enum(["contracted", "not_contracted", "suspended"]),
    "source": z.string().min(1),
    "effective_from": z.string().datetime({ offset: true }).optional(),
    "effective_until": z.string().datetime({ offset: true }).optional(),
    "version": z.number().int().min(1),
    "changed_by": z.string().optional(),
    "changed_at": z.string().datetime({ offset: true })
  }).strict().nullable(),
  "state": z.unknown().refine((value) => [productAreaStateSchema, z.null()].filter((variant) => variant.safeParse(value).success).length === 1, "Expected exactly one supported variant").pipe(z.union([productAreaStateSchema, z.null()])),
  "readiness": z.object({
    "status": z.enum(["unknown", "ready", "needs_attention"]),
    "reason_code": z.string(),
    "observed_at": z.string().datetime({ offset: true }).optional()
  }).strict(),
  "display_status": z.enum(["unresolved", "unavailable", "off", "setup_required", "on", "suspended"]),
  "reason_code": z.string(),
  "actions": z.array(z.object({
    "id": z.enum(["start_setup"]),
    "destination": z.enum(["product_area_setup"])
  }).strict()),
  "runtime_effect": runtimeEffectSchema,
  "retained_configuration": z.boolean()
}).strict();

export const productAreaListSchema = z.object({
  "data": z.array(productAreaSchema)
}).strict();

export const setupPreviewSchema = z.object({
  "area": productAreaIdSchema,
  "inventory": productAreaSchema,
  "eligible": z.boolean(),
  "blockers": z.array(z.string()),
  "requirements": z.array(z.string()),
  "expected_version": z.number().int().min(0),
  "entitlement_version": z.number().int().min(0),
  "operation_ref": z.string().min(1),
  "checked_at": z.string().datetime({ offset: true })
}).strict();

export const activationPreviewSchema = z.object({
  "area": productAreaIdSchema,
  "to": z.enum(["on", "off"]),
  "inventory": productAreaSchema,
  "eligible": z.boolean(),
  "blockers": z.array(z.string()),
  "retained_configuration": z.boolean(),
  "effect": z.enum(["none", "frontline_sign_in_stops", "area_stops"]),
  "expected_version": z.number().int().min(0),
  "entitlement_version": z.number().int().min(0),
  "operation_ref": z.string().min(1),
  "checked_at": z.string().datetime({ offset: true })
}).strict();

export const setupTransitionSchema = z.object({
  "area": productAreaIdSchema,
  "operation_ref": z.string().min(1),
  "before": productAreaStateSchema,
  "after": productAreaStateSchema,
  "replayed": z.boolean(),
  "cleared_offerings": z.array(z.string())
}).strict();

export const entitlementResponseSchema = z.object({
  "status": z.enum(["contracted", "not_contracted", "suspended"]),
  "source": z.string().min(1),
  "effective_from": z.string().datetime({ offset: true }).optional(),
  "effective_until": z.string().datetime({ offset: true }).optional(),
  "version": z.number().int().min(1),
  "changed_by": z.string().optional(),
  "changed_at": z.string().datetime({ offset: true })
}).strict();
